export default "__VITE_ASSET__DV4BHd3e__"